export var ENTITY = "assets";
export var REDUCER_KEY = "ASSETS_V2";
export var BASE_PATH_ENTITY = "assets";
export var GENERATOR_PARAMS = {
    entity: ENTITY,
    reducerKey: REDUCER_KEY,
    basePathEntity: BASE_PATH_ENTITY,
};
